import './ProfessionalAgentLanding.css';

export default function ProfessionalAgentLanding({ search = '' }) {
  const query = search && search.startsWith('?') ? search : search ? `?${search}` : '';

  return (
    <main className="professional-agent-landing" aria-label="SO Agent partner program">
      <iframe
        className="professional-agent-landing-frame"
        src={`/agent-landing/index.html${query}`}
        title="SO Agent partner program"
        loading="eager"
        referrerPolicy="same-origin"
      />
    </main>
  );
}
